import React from 'react';
import { useChannelPreviewInfo, } from '../ChannelPreview/hooks/useChannelPreviewInfo';
import { CloseIcon } from './icons';
import { useChannelStateContext } from '../../context/ChannelStateContext';
import { useTranslationContext } from '../../context/TranslationContext';
export const ThreadHeader = (props) => {
    const { closeThread, overrideImage, overrideTitle } = props;
    const { t } = useTranslationContext('ThreadHeader');
    const { channel } = useChannelStateContext('');
    const { displayTitle } = useChannelPreviewInfo({
        channel,
        overrideImage,
        overrideTitle,
    });
    return (React.createElement("div", { className: 'str-chat__thread-header' },
        React.createElement("div", { className: 'str-chat__thread-header-details' },
            React.createElement("div", { className: 'str-chat__thread-header-title' }, t('Thread')),
            React.createElement("div", { className: 'str-chat__thread-header-subtitle' }, displayTitle)),
        React.createElement("button", { "aria-label": t('aria/Close thread'), className: 'str-chat__close-thread-button', "data-testid": 'close-button', onClick: closeThread },
            React.createElement(CloseIcon, null))));
};
